export class PvcWindowMullionRule {
    private widthLimit: number = 1500;
    private mullionSizeRestriction: string = '68 mm';

    public validate(productHeight: number, isEligibleForPvcMullionRule: boolean): boolean {
        return productHeight > this.widthLimit && isEligibleForPvcMullionRule;
    }

    public getMullionSizeRestriction(): string {
        return this.mullionSizeRestriction;
    }
}
